var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("settings-property", {
    attrs: {
      label: _vm.resource("JourneyBuilder_FilterSettings_Arrival_DisplayName"),
      icon: "fas fa-plane-arrival"
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function(ref) {
          var id = ref.id
          return [
            _c(
              "v-select",
              {
                staticClass: "form-control",
                attrs: {
                  "input-id": id,
                  options: _vm.availableConditions,
                  disabled:
                    !_vm.canWrite || _vm.availableConditions.length === 0,
                  clearable: false,
                  label: "name",
                  searchable: "",
                  filterable: "",
                  taggable: "",
                  "close-on-select": ""
                },
                model: {
                  value: _vm.selectedValue,
                  callback: function($$v) {
                    _vm.selectedValue = $$v
                  },
                  expression: "selectedValue"
                }
              },
              [_c("div", { attrs: { slot: "no-options" }, slot: "no-options" })]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }